import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import { Eyebrow } from '../Eyebrow';

type SectionHeadingAlign = 'left' | 'center';

type SectionHeadingProps = {
  kicker?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  align?: SectionHeadingAlign;
  shimmer?: boolean;
  className?: string;
  as?: 'h1' | 'h2' | 'h3';
};

export function SectionHeading({
  kicker,
  title,
  subtitle,
  align = 'center',
  shimmer = false,
  className,
  as = 'h2',
}: SectionHeadingProps) {
  const Heading = as;
  return (
    <div
      className={clsx(
        'flex flex-col gap-4',
        align === 'center' ? 'items-center text-center' : 'items-start text-left',
        className,
      )}
    >
      {kicker ? <Eyebrow tone="gold">{kicker}</Eyebrow> : null}
      <Heading
        className={clsx(
          'font-display tracking-tight',
          as === 'h1'
            ? 'text-4xl leading-tight md:text-5xl lg:text-6xl'
            : 'text-3xl leading-tight md:text-4xl lg:text-5xl',
          shimmer ? 'text-gold-shimmer' : 'text-parchment',
        )}
      >
        {title}
      </Heading>
      {subtitle ? (
        <p className="max-w-2xl text-base leading-relaxed text-neutral-100 md:text-lg">
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
